/* 🤖 this file was generated by svg-to-ts */
export const matIconPlaylistPlay: {
  name: 'playlist-play';
  data: string;
} = {
  name: 'playlist-play',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 10h11v2H3zm0-4h11v2H3zm0 8h7v2H3zm13-1v8l6-4z"/></svg>`
};
